import { useEffect, useRef } from "react";

import { type ValueInspectorRowInfo } from "../traverseValue/ValueInspectorRowInfo";

/**
 * Primitives for
 */
export function useInspectorKeyNavigation(rows: ValueInspectorRowInfo[]) {
	const expandButtonRefList = useRef<(HTMLButtonElement | null)[]>([]);

	useEffect(() => {
		expandButtonRefList.current = expandButtonRefList.current.slice(0, rows.length);
	}, [rows]);

	const makeButtonRef = function (i: number): React.RefCallback<HTMLButtonElement> {
		return (el: HTMLButtonElement) => {
			expandButtonRefList.current[i] = el;
		};
	};
	const makeNavigator = (i: number) => new InspectorKeyNavigator(i, expandButtonRefList, rows);
	return [makeButtonRef, makeNavigator] as const;
}

export class InspectorKeyNavigator {
	constructor(
		private readonly _i: number,
		private readonly _expandButtonRefList: React.MutableRefObject<(HTMLButtonElement | null)[]>,
		private readonly _rows: ValueInspectorRowInfo[]
	) {}

	focusCurrentButton() {
		this._expandButtonRefList.current[this._i]?.focus();
	}

	focusButtonOfParent() {
		const depth = this._rows[this._i]?.path.length || 0;

		for (let j = this._i - 1; j >= 0; j--) {
			const prevDepth = this._rows[j]?.path.length || 0;
			if (prevDepth >= depth) {
				continue;
			}

			const next = this._expandButtonRefList.current[j];
			if (next) {
				next.focus();
				break;
			}
		}
	}

	focusPreviousButton() {
		for (let j = this._i - 1; j >= 0; j--) {
			const prev = this._expandButtonRefList.current[j];
			if (prev) {
				prev.focus();
				break;
			}
		}
	}

	focusNextButton() {
		for (let j = this._i + 1; j < this._expandButtonRefList.current.length; j++) {
			const next = this._expandButtonRefList.current[j];
			if (next) {
				next.focus();
				break;
			}
		}
	}
}
